import { t } from "ttag";

import * as Urls from "metabase/lib/urls";
import type Question from "metabase-lib/v1/Question";
import type {
  CacheStrategy,
  CacheableDashboard,
  CacheableModel,
} from "metabase-types/api";

export type SidebarPageSetter = (page: "default" | "caching") => void;

export type CacheableItem = {
  id: number;
  model: CacheableModel;
  strategy?: CacheStrategy;
  name: string;
  iconModel: "card" | "dashboard";
};

export const getItemId = (
  model: CacheableModel,
  item: CacheableDashboard | Question,
) =>
  model === "dashboard"
    ? (item as CacheableDashboard).id
    : (item as Question).id();

export const getItemName = (
  model: CacheableModel,
  item: CacheableDashboard | Question,
) =>
  model === "dashboard"
    ? (item as CacheableDashboard).name
    : ((item as Question).displayName() ?? t`Untitled question`);

export const getItemUrl = (
  model: CacheableModel,
  item: { id: number; name: string },
) => (model === "dashboard" ? Urls.dashboard(item) : Urls.question(item));
